import React from "react";
import type { RenderSiteProps } from "./RenderSite";
import { externalLinkProps } from "./externalLinkProps";
import { I18n } from "../i18n";

export const Hero: React.FC<RenderSiteProps> = (props) => {
  const color = props.site.color;
  const color_weight = props.site.color_weight;
  const { textColor } = props.site;
  const heroImageMetadata = props.site.hero?.image_metadata;
  const i18n = I18n(props.site.language);
  const hasSecondaryCta =
    Boolean(props.site.hero?.secondary_cta) &&
    Boolean(props.site.hero?.secondary_cta_link);
  const hasPrimaryCta =
    Boolean(props.site.hero?.cta) &&
    Boolean(props.site.hero?.cta_link);
  return (
    <section
      id="hero"
      className={`min-h-[90vh] flex flex-col items-center justify-center bg-gradient-to-b from-${color}-${color_weight} to-${color}-${
        color_weight - 100
      } text-center px-6 py-20`}
    >
      {props.site.hero?.image_uri && (
        <div className="relative py-8 mx-auto max-w-2xl  overflow-hidden">
          <img
            width={heroImageMetadata?.width}
            height={heroImageMetadata?.height}
            src={props.site.hero.image_uri}
            alt={props.site.hero?.title || i18n["Hero image"]}
            className="w-full rounded-lg"
          />
        </div>
      )}
      <div
        className={`max-w-4xl mx-auto magictime vanishIn text-${textColor} p-8 rounded`}
      >
        <h1 className="text-5xl md:text-7xl font-extrabold mb-6 logo first-letter:uppercase">
          {props.site.hero?.title}
        </h1>
        {props.site.hero?.description && (
          <p className="text-lg md:text-2xl mb-8 first-letter:uppercase">
            {props.site.hero.description.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        )}
        {(hasPrimaryCta || hasSecondaryCta) && (
          <div className="flex flex-col items-center gap-4 mb-12 sm:flex-row sm:justify-center sm:space-x-4">
            {hasSecondaryCta && (
              <a
                href={props.site.hero?.secondary_cta_link}
                className="bg-white/90 text-gray-900 py-3 px-8 rounded-full shadow-lg text-lg md:text-xl hover:bg-white transition duration-300 first-letter:uppercase"
                {...externalLinkProps(props.site.hero?.secondary_cta_link)}
              >
                {props.site.hero?.secondary_cta}
              </a>
            )}
            {hasPrimaryCta && (
              <a
                href={props.site.hero?.cta_link}
                className={`bg-${color}-500 text-white py-3 px-8 rounded-full shadow-lg text-lg md:text-xl hover:bg-${color}-700 transition duration-300 first-letter:uppercase`}
                {...externalLinkProps(props.site.hero?.cta_link)}
              >
                {props.site.hero?.cta}
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
